import React from "react";
import Slider from "./slider";
import TopicBox from "./topic-box";

export interface SliderFilterProps {
  title: string;
  range: number[];
  selectedRange?: number[];
  onChange?: (range: number[]) => void;
  specId: number;
}

function SliderFilter({
  title,
  range,
  selectedRange,
  onChange,
  specId
}: SliderFilterProps) {
  let activeRange = selectedRange || range;
  const shouldRenderSlider = range[0] !== range[1];

  return (
    shouldRenderSlider ?(
      <TopicBox title={title}>
        <Slider
          range={range}
          selectedRange={activeRange}
          onUpdate={(data: number[]) => {
            (data[0] !== activeRange[0] || data[1] !== activeRange[1]) &&
              onChange &&
              onChange(data);
          }}
          specId={specId}
        />
      </TopicBox>
    ) :null
  );
}

export default SliderFilter;
